import { createContext  } from 'react';

const UserContext = createContext({ user: {
  id: null,
  name: null,
  roomId: null
}, setUser: () => {} });

export default UserContext;
